"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _RadioGroup = require("../RadioGroup");
var _appendCss = _interopRequireDefault(require("../../utils/appendCss"));
var _RadioButton_css = _interopRequireDefault(require("./RadioButton_css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Radio Button component used only in conjunction with RadioGroup component.
 *
 * @class RadioButton
 * @extends {Component}
 */
class RadioButton extends _react.Component {
  constructor(props) {
    super(props);
    /**
     * Click event handler
     *
     * @memberof RadioButton
     * @param {object} event
     */
    (0, _defineProperty2.default)(this, "handleClick", event => {
      if (this.props.isDisabled) return;
      if ("onChange" in this.props.context && typeof this.props.context.onChange === "function") {
        this.props.context.onChange({
          label: this.props.label,
          value: this.props.value
        }, event);
      }
    });
    (0, _appendCss.default)("arc_rdo", _RadioButton_css.default);
    this.inputId = this.props.id ? this.props.id : (0, _lodash.uniqueId)("rdoel_");
  }
  render() {
    const {
      label,
      value,
      isDisabled,
      context,
      themeColor,
      additionalProps
    } = this.props;
    const {
      name,
      selectedValue
    } = context;
    let isChecked = false;
    if (selectedValue !== undefined) {
      isChecked = this.props.value === selectedValue || this.props.label === selectedValue;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "radio__elem"
    }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
      type: "radio",
      checked: isChecked,
      id: this.inputId,
      name: name,
      value: value,
      onChange: this.handleClick
    }, isDisabled ? {
      disabled: true
    } : {}, additionalProps)), /*#__PURE__*/_react.default.createElement("label", {
      className: (0, _classnames.default)({
        "t-body-large": true,
        "disabled": isDisabled,
        ["".concat(themeColor, "-color")]: true
      }),
      htmlFor: this.inputId
    }, label));
  }
}

/**
 * Applies context required to wire RadioButton up with RadioGroup component
 *
 * @param {class} Component
 */
const applyContext = Component => {
  return /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(_RadioGroup.RadioGroupContext.Consumer, null, context => {
    return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
      forwardedRef: ref,
      context: context
    }));
  }));
};
RadioButton.propTypes = {
  /** label for radio button */
  "label": _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /** value HTML attribute */
  "value": _propTypes.default.string,
  /** id HTML attribute */
  "id": _propTypes.default.string,
  /** specifies whether button is disabled */
  "isDisabled": _propTypes.default.bool,
  /** context object from RadioGroup component */
  "context": _propTypes.default.object,
  /** Theme color variant [primary, accent, error, success] */
  "themeColor": _propTypes.default.oneOf(["primary", "accent", "error", "success"]),
  /** allows for additional key:value pairs to apply to the input HTML element */
  "additionalProps": _propTypes.default.object,
  /** NOTE: prop name is "ref". a React REF object reference that is applied to the radio element. */
  "React REF (ref)": _propTypes.default.object
};
RadioButton.defaultProps = {
  value: "",
  isDisabled: false,
  context: {
    name: "",
    selectedValue: undefined
  },
  themeColor: "primary"
};
var _default = exports.default = applyContext(RadioButton);